export enum NavBarRoutes {
    HOME = "Home",
    ABOUT = "About",
    PROJECTS = "Projects",
    BLOG = "Blog",
    CONTACT = "Contact",
}